import { DMPClient } from './dmp';

declare global {
	interface Window {
		DMP?: DMPClient;
	}
}

const dmp = new DMPClient();
window.DMP = dmp;

export default dmp;
export { DMPClient };
export type { DmpConfig, TrackOptions } from './dmp';
